import { Outlet } from "react-router-dom";

import DashboardNav from "./dashboard-nav/DashboardNav";

import "./Dashboard.css";

export default function DashRootLayout() {
  return (
    <>
      <div className="dashboard-wrapper-parent">
        <div className="dashboard-wrapper-parent__nav">
          <DashboardNav />
        </div>
        <div className="dashboard-wrapper-parent__pages">
          <Outlet />
        </div>
      </div>
    </>
  );
}
